import type { MaterialSummary } from '@site/shared'
import { LocaleLink as Link } from '@/components/LocaleLink'

export function MaterialCard({ material: m }: { material: MaterialSummary }) {
  return (
    <Link to={`/materialer/${m.slug}`} className="card">
      {m.category && <span className="eyebrow">{m.category.name}</span>}
      <span className="card-title">{m.title}</span>
      {m.summary && <span className="muted small">{m.summary}</span>}
    </Link>
  )
}
